import logo from './logo.svg';
import './App.css';
import Header from './component/Header/Header';
import { Outlet } from 'react-router-dom';

function App() {
  return (
    <>
      <Header />
      <Outlet />

    </>
  );
}

export default App;
